<div style="width: 100%;">
    <div class="wrapper">

        <div class="header">
            <h2 ngClass="{{process.isStep ? 'step-header' : ''}}">{{ process.isStep ? 'Step ' +
                process.stepIndex + ':
                ' : ''}}{{ process.typeStr }}</h2>
            <div class="control-buttons">
                <app-task-view [task]="process" [showCheckStatus]="false" [showRecalculateButton]="true"
                    [showStatus]="false" [showReindexButton]="true" [showTaskTabButton]="false"
                    (deleteProcess)="deleteProcess($event)">
                </app-task-view>
            </div>
        </div>


        <app-replace-land-use-ids-general-statistic [process]="process"
            style="grid-column-start: 1; grid-column-end: 1; grid-area: section1_1;"></app-replace-land-use-ids-general-statistic>
        <app-process-messages-section [process]="process"
            style="grid-column-start: 1; grid-column-end: 1; grid-area: section2_1;"
            style="padding-right: 10px;"></app-process-messages-section>
        <app-replace-land-use-id-statistic-section [replaceLandUseStatistic]="process.replaceLandUseStatistic"
            style="grid-column-start: 2; grid-column-end: 2; grid-row-start: 2; grid-row-end: 3; grid-area: procStat;"></app-replace-land-use-id-statistic-section>
    </div>

    <mat-tab-group class="mat-elevation-z0" #tabs mat-stretch-tabs="false">
        <mat-tab label="Replaced Land Use Ids: Old (Updated) New">
            <div>
                <app-replaced-land-use-ids-list
                    [combinedReplaceIdStatistics]="combinedReplaceIdStatistics"></app-replaced-land-use-ids-list>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>